import { createSlice } from "@reduxjs/toolkit";
export const sideBarSlice = createSlice({
  name: "sideBar",
  initialState: {
    toggleSideBar: true,
  },
  reducers: {
    updateOpenReducer: (state, action) => {
      state.toggleSideBar = action.payload;
      return state;
    },
  },
});

export const { updateOpenReducer } = sideBarSlice.actions;
export default sideBarSlice.reducer;
